import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom"; 
import "styles/scss/header.scss"; 
import Sitemap from "pages/sitemap/Sitemap";
import { getSessionItem } from 'utils/storage';

const Header = () => {
    const location = useLocation(); 
    const [isTransparent, setIsTransparent] = useState(true);
    const [isSitemapOpen, setIsSitemapOpen] = useState(false);
    const [isAboutMenuOpen, setIsAboutMenuOpen] = useState(false); // 회사소개 서브메뉴 상태 추가

    const sessionUser = getSessionItem('loginUser');
    const sessionUserId = sessionUser?.id;

    useEffect(() => {
        if (location.pathname !== "/") {
            setIsTransparent(false);
            return;
        }

        const handleScroll = () => {
            if (window.scrollY > window.innerHeight * 0.1) {
                setIsTransparent(false);
            } else {
                setIsTransparent(true);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [location.pathname]);

    return (
        <>
            <header className={`header ${isTransparent ? "transparent" : "solid"}`}>
                <div className="container header-flex">
                    <a href="/" className="logo">
                        <div className="logo-img"></div>
                    </a>
                    <nav>
                        <ul>
                            <li
                                className="dropdown"
                                onMouseEnter={() => setIsAboutMenuOpen(true)}
                                onMouseLeave={() => setIsAboutMenuOpen(false)}
                            >
                                <a href="/about" className={location.pathname.includes("/about") ? "active" : ""}>
                                    회사소개
                                </a>
                                {isAboutMenuOpen && (
                                    <ul className="submenu">
                                        <li><a href="/about">비전,연혁</a></li>
                                        <div className="line"></div>
                                        <li><a href="about/organization/:aboutId">조직도</a></li>
                                    </ul>
                                )}
                            </li>
                            <li>
                                <a href="/business" className={location.pathname === "/business" ? "active" : ""}>
                                    비즈니스
                                </a>
                            </li>
                            <li>
                                <a href="/news" className={location.pathname.includes("/news") ? "active" : ""}>
                                    N소식
                                </a>
                            </li>
                            <li>
                                <a href="/recruitment" className={location.pathname === "/recruitment" ? "active" : ""}>
                                    인재채용
                                </a>
                            </li>
                            {/* 관리자로 접속했을때만 보여지는 메뉴 */}
                            {sessionUserId !== undefined && sessionUserId !== null && 
                            <li>
                                <a href="/psts" className={location.pathname === "/psts" ? "active" : ""}>
                                    게시글관리
                                </a>
                            </li>
                            }
                            {/* 관리자로 접속했을때만 보여지는 메뉴 */}
                            {sessionUserId === 'masteruser' && 
                            <li>
                                <a href="/account" className={location.pathname === "/account" ? "active" : ""}>
                                    계정관리
                                </a>
                            </li>                
                            }
                            <li>
                                <button className="sitemap-btn" onClick={() => setIsSitemapOpen(!isSitemapOpen)}>
                                </button>
                            </li>
                        </ul>
                    </nav>
                    <div className="tab-sitemap">
                        <button className="sitemap-btn" onClick={() => setIsSitemapOpen(!isSitemapOpen)}>
                        </button>
                    </div>
                </div>
            </header>
            <Sitemap isOpen={isSitemapOpen} onClose={() => setIsSitemapOpen(false)} />
        </>
    );
};

export default Header;
